module.exports = __webpack_public_path__ + "static/media/DNA-icon.47242c93.svg";